import React from 'react';
import StatusPill from './StatusPill';
import { ageMinutes, formatMoney, urgencyMeta } from '../lib/formatters';
import { getDelayClass } from '../lib/delayAttribution';

function flowStep(stage) {
  const stages = ['new', 'awaiting_store', 'ready_for_driver', 'out_for_delivery', 'delivered'];
  const idx = Math.max(0, stages.indexOf(stage));
  return Math.min(100, Math.round(((idx + 1) / stages.length) * 100));
}

function nextMoveLabel(order) {
  if (order.issueFlag || order.stage === 'issue') return 'Fix issue';
  if (order.stage === 'new') return 'Send store';
  if (order.stage === 'awaiting_store') return 'Await store';
  if (order.stage === 'ready_for_driver') return 'Assign driver';
  if (order.stage === 'out_for_delivery') return 'Track road';
  if (order.stage === 'delivered') return 'Complete';
  return 'Review';
}

export default function OrderList({ orders, selectedId, onSelect }) {
  if (!orders.length) {
    return <div className="link-empty-state">No orders in this lane yet.</div>;
  }

  return (
    <div className="link-queue-list">
      {orders.map((order) => {
        const active = selectedId === order.id;
        const urgency = urgencyMeta(order);
        const age = ageMinutes(order.placedAt || order.createdAt);
        const delay = order.delay || {};
        const isHot = order.issueFlag || order.stage === 'issue' || age >= 45 || delay.severity === 'critical';
        return (
          <button
            key={order.id}
            type="button"
            onClick={() => onSelect(order)}
            className={`link-queue-card ${active ? 'link-queue-card-active' : ''} ${isHot ? 'link-queue-card-hot' : ''} ${getDelayClass(delay)}`}
          >
            <div className="link-queue-card-top">
              <div>
                <div className="link-order-number">{order.orderNumber || order.id}</div>
                <div className="mt-1 text-sm font-bold text-white">{order.customerName}</div>
                <div className="mt-1 text-xs text-slate-500">{order.suburb || 'No suburb'} · {order.store || 'No store'}</div>
              </div>
              <div className="link-queue-card-status">
                <StatusPill stage={order.stage} />
                <span className={isHot ? 'link-chip link-chip-hot' : 'link-chip link-chip-soft'}>{delay?.isDelayed ? delay.label : urgency.label}</span>
              </div>
            </div>

            <div className="link-order-flow">
              <span style={{ width: `${flowStep(order.stage)}%` }} />
            </div>

            <div className="link-queue-meta-grid">
              <span>Online <b>{order.assignedOnline || '—'}</b></span>
              <span>Driver <b>{order.assignedDriver || 'Unassigned'}</b></span>
              <span>Age <b>{order.timePlaced || `${age}m`}</b></span>
              <span>Total <b>{formatMoney(order.total)}</b></span>
            </div>

            <div className="link-queue-card-bottom">
              <span className="link-next-mini">{delay?.isDelayed ? `${delay.label}: ${delay.durationLabel}` : `Next: ${nextMoveLabel(order)}`}</span>
              {order.proof?.photoUrl ? <span className="link-proof-mini">Proof</span> : null}
            </div>
          </button>
        );
      })}
    </div>
  );
}
